import React from "react";
import { CheckCircle, Award, Users, Cog } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";

const About = () => {
  const highlights = [
    {
      icon: <Award className="h-8 w-8 text-blue-600" />,
      title: "30+ Anni di Esperienza",
      description: "Leader nel settore della produzione di fustelle a nastro"
    },
    {
      icon: <Cog className="h-8 w-8 text-blue-600" />,
      title: "Tecnologia Avanzata",
      description: "Sistema CAD-CAM per precisione e qualità superiore"
    },
    {
      icon: <Users className="h-8 w-8 text-blue-600" />,
      title: "Team Qualificato",
      description: "Personale esperto sempre a disposizione della clientela"
    }
  ];

  const sectors = [
    "Calzature",
    "Pelletteria", 
    "Abbigliamento",
    "Guarnizioni",
    "Settore Automobilistico",
    "Sedili e Allestimenti Interni"
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-gray-900 to-gray-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">LA NOSTRA AZIENDA</h1>
            <p className="text-xl text-gray-200 leading-relaxed">
              Il Fustellificio Ideal s.n.c è un'azienda leader con oltre 30 anni di esperienza 
              nel settore della produzione di fustelle a nastro
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Chi Siamo
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  Il Fustellificio Ideal s.n.c è un'azienda leader con oltre 30 anni di esperienza 
                  nel settore della produzione di fustelle a nastro; in particolare per le calzature, 
                  la pelletteria, l'abbigliamento, le guarnizioni e nel settore automobilistico 
                  (sedili e allestimento interno).
                </p>
                <p>
                  Il Fustellificio Ideal è composto da persone qualificate, sempre a disposizione 
                  per venire incontro ai problemi della clientela.
                </p>
                <p>
                  La conservazione dei metodi artigianali accoppiata con l'utilizzo di macchinari 
                  tecnologicamente avanzati quali CAD-CAM ci ha permesso di posizionarci all'apice 
                  del settore.
                </p>
                <p>
                  Forniamo in tempi brevissimi prodotti di ottima qualità curati nei minimi 
                  particolari e proponiamo una serie di servizi tale da soddisfare i clienti 
                  più esigenti.
                </p>
              </div>
            </div>
            <div>
              <video
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-96 object-cover rounded-lg shadow-xl"
              >
                <source src="https://customer-assets.emergentagent.com/job_modern-ideal/artifacts/f66g71qs_copy_266B1AE2-2507-489E-875F-70850D826F8E.MOV" type="video/mp4" />
                Impossibile riprodurre il video. Il tuo browser non supporta questo formato.
              </video>
            </div>
          </div>

          {/* Highlights */}
          <div className="grid md:grid-cols-3 gap-8 mb-20">
            {highlights.map((highlight, index) => (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-8 text-center">
                  <div className="mb-6 flex justify-center">
                    {highlight.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    {highlight.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {highlight.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Sectors */}
          <div className="bg-gray-50 rounded-2xl p-12">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Settori di Specializzazione
              </h2>
              <p className="text-lg text-gray-600">
                Operiamo con successo in diversi settori industriali
              </p>
            </div>
            <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6">
              {sectors.map((sector, index) => (
                <div key={index} className="text-center">
                  <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
                    <CheckCircle className="h-8 w-8 text-green-600 mx-auto mb-3" />
                    <p className="font-medium text-gray-800">{sector}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;